module.exports = __webpack_public_path__ + "img/popularity-unchecked-ms.1f3f3bef.png";